import styled from 'styled-components'
import Hotel from 'components/hotel'
import { Waypoint } from 'react-waypoint'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import styles from './styles.module.scss'
import { categories } from '../../global/categories'
import { useEffect, useState } from 'react'

interface WaypointEvent {
  currentPosition: string
  previousPosition: string
}

interface Props {
  category: string
  hotelList: Map<string, string | number>[]
  id: string
  request: 'loading' | 'error' | 'ready'
  topWaypointLeaveHandler: (id: string) => void
  bottomWaypointLeaveHandler: (id: string) => void
}

export function HotelCategory({
  category,
  hotelList,
  id,
  request,
  topWaypointLeaveHandler,
  bottomWaypointLeaveHandler
}: Props) {
  const segmentClasses = `ui vertical ${request} ${styles.hotelCategory} segment`
const [firstPlace, setFirstPlace] = useState<Map<string, string | number> | undefined>(undefined) 
const [firstHotelProps, setFirstHotelProps] = useState<any>(undefined)
  const hotelMapToProps = (hotel: Map<string, string | number>): any  => ({
    address: hotel.get('Adresse') as string,
    category: hotel.get('Kategorie') as string,
    description: hotel.get('Legende')!,
    host: hotel.get('Gastgeber')!,
    image: hotel.get('Bild')!,
    winnerText: hotel.get('Siegertext')!,
    name: hotel.get('Name')!,
    phone: hotel.get('Telefon')!,
    previousRank: hotel.get('RangimVorjahr')!,
    price: hotel.get('Preis')!,
    rank: String(hotel.get('Rang'))!,
    stars: String(hotel.get('Sterne'))!,
    typeOfStay: hotel.get('TypderÜbernachtung')!,
    website: hotel.get('Webseite')!
  })
useEffect(() => {
  // sort the hotel list and retrieve the first place
  hotelList.sort((a, b) => +(a.get('Rang') ?? 0) - +(b.get('Rang') ?? 0))
  const newFirstPlace = hotelList[0]
  // console.log(firstPlace);
  
  let firstHotelProps 
  if (newFirstPlace) {
    setFirstHotelProps(hotelMapToProps(newFirstPlace))
  }
  setFirstPlace(newFirstPlace)
}, [hotelList])


  return (
    <main className={segmentClasses} id={id}>
      <Waypoint
        scrollableAncestor={window}
        onLeave={({ previousPosition, currentPosition }) => {
          if (
            previousPosition === Waypoint.inside &&
            currentPosition === Waypoint.above
          ) {
            topWaypointLeaveHandler(id)
          }
        }}
        topOffset='25%'
      />

      <Waypoint
        scrollableAncestor={window}
      />

      <div className='ui text container'>
        <CategoryTitle
          className='categoryHeader'
          style={{ color: categories[category][1] }}
        >
          {category}
        </CategoryTitle>
        <div className='ui horizontal divider'>
          <i className='grey disabled sun icon' />
        </div>
      </div>

      <div className='ui container'>
        <div
          className={`ui segment ${styles.winnerSegment}`}
          style={{ backgroundColor: "var(--gray-5)" }}
        >
          <div className='ui middle aligned mobile reversed two column stackable grid'>
            <div className='ui column mobile hidden'>
              <div className='ui vertical very fitted text basic segment'>
                <h3
                  className='ui centered header'
                  style={{ color: categories[category][1] }}
                >
                  <div className={`sub header ${styles.subHeader}`}>
                    {firstPlace && firstPlace.get('Name')}
                  </div>
                  {firstPlace && firstPlace.get('SiegertextTitel')}
                </h3>

                <p>{firstPlace && firstPlace.get('Siegertext')}</p>
              </div>
            </div>
            <div className='ui column'>
            {firstPlace && <Hotel className='fluid' {...firstHotelProps} />}

            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui three doubling stackable cards'>
            {hotelList.slice(1).map(hotel => {
              const hotelProps = hotelMapToProps(hotel)
              return (
                <Hotel
                  {...hotelProps}
                  className='normal-hotel'
                  key={hotelProps.name + '-' + hotelProps.rank}
                />
              )
            })}
          </div>
        </div>
      </div>
      <Waypoint
        scrollableAncestor={window}
        onLeave={({ previousPosition, currentPosition }) => {
          if (
            previousPosition === Waypoint.inside &&
            currentPosition === Waypoint.below
          ) {
            bottomWaypointLeaveHandler(id)
          }
        }}
        bottomOffset='25%'
      />
    </main>
  )
}

const CategoryTitle = styled.h2`
  font-size: 5.2em;
  @media screen and (max-width: 599px) {
    font-size: 3.2em;
  }
  font-family: var(--font-source);
  font-weight: 700;
  text-align: center;
`
